import { Box, Stack } from '../../shared/layouts';
import Container from '../login/LoginContainer';
import { useTranslation } from 'react-i18next';

const SignRequestSigned = () => {
  const { t } = useTranslation();

  return (
    <Container hideUwKluisLogo>
      <Box fontScale="2xl" fontWeight="bold">
        {t('Tekenverzoek afgerond')}
      </Box>
      <Stack space="m">{t('Bedankt voor het ondertekenen van het document. Het getekende document wordt nu verwerkt. Over enkele ogenblikken is deze te downloaden. Je kunt de pagina verlaten.')}</Stack>
    </Container>
  );
};

export default SignRequestSigned;
